(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.contact-form__form').forEach(function (form) {
      if (form.dataset.hpBound === '1') return;
      form.dataset.hpBound = '1';

      form.addEventListener('submit', function (event) {
        var hpField = form.querySelector('input[name="contact[website]"]');
        if (hpField && hpField.value.trim() !== '') {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
